/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelQuickStack64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelQuickStack64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 15C15.4477 15 15 15.4477 15 16V48C15 48.5523 15.4477 49 16 49H48C48.5523 49 49 48.5523 49 48V16C49 15.4477 48.5523 15 48 15H16ZM32 16H16V31H32V16ZM33 48H48V16H33V48ZM32 48V32H16V48H32Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelQuickStack64Icon.tags = ['add', 'panel', 'layout', 'grid', 'arrange'];

AddPanelQuickStack64Icon.category = '64x64 (Add panel)';

AddPanelQuickStack64Icon.iconSize = 64;
